export default __webpack_public_path__ + "ff4346b8f7d467bd6e77c6b49c9e4889.svg";